import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface StandaloneComposerMessageProps {
  title: React.ReactNode;
  description: React.ReactNode;
}

/*
 * Styles.
 */

const StyledMessageContainerDiv = styled.div`
  grid-row: 1 / span 4;
  grid-column: 1;
  ${center()};
`;

const StyledMessageHeaderDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.semibold};
  line-height: 20px;
  padding: 25px 0 13px;
`;

const StyledMessageBodyDiv = styled.div`
  text-align: center;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.medium};
  line-height: 150%;
`;

export const StandaloneComposerMessage: FC<StandaloneComposerMessageProps> = (props) => {
  const {title, description} = props;

  return (
    <StyledMessageContainerDiv>
      <StyledMessageHeaderDiv>{title}</StyledMessageHeaderDiv>
      <StyledMessageBodyDiv>{description}</StyledMessageBodyDiv>
    </StyledMessageContainerDiv>
  );
};
